import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SavedReport } from '../models/saved-report.model';

/** Mirrors `SavedSearchService`'s shape - same endpoint conventions, its own table. */
@Injectable({
  providedIn: 'root'
})
export class SavedReportService {

  private _endpoint: string = environment.api.endpoint;

  constructor(private httpClient: HttpClient) { }

  getAllByEntity(entityName: string): Observable<SavedReport[]> {
    if (!entityName || entityName === '') {
      throw new Error('You must supply a valid entity name');
    }

    return this.httpClient.get(this._endpoint + 'saved-report?filter=entity||eq||' + entityName).pipe(map((data) => {
      return <SavedReport[]>data;
    }));
  }

  getById(id: number): Observable<SavedReport> {
    if (!id || id === -1) {
      throw new Error('You must provide a valid id for getById');
    }

    return this.httpClient.get(this._endpoint + 'saved-report/' + id).pipe(map((data) => {
      return <SavedReport>data;
    }));
  }

  create(report: SavedReport): Observable<SavedReport> {
    if (!report) {
      throw new Error('saved report service: you must supply a report object for saving');
    }

    delete report.createdAt;
    delete report.updatedAt;

    if (report.id > 0) {
      throw new Error('saved report service: cannot create an existing object');
    }

    delete report.id;

    return this.httpClient.post(this._endpoint + 'saved-report',
      JSON.stringify(report),
      { headers: { 'Content-Type': 'application/json' } }).pipe(map((data) => {
        return <SavedReport>data;
      }));
  }

  update(report: SavedReport): Observable<SavedReport> {
    if (!report) {
      throw new Error('saved report service: you must supply a report object for saving');
    }

    delete report.createdAt;
    delete report.updatedAt;

    if (!report.id || report.id === -1) {
      throw new Error('saved report service: cannot update a record without id');
    }

    return this.httpClient.put(this._endpoint + 'saved-report/' + report.id,
      JSON.stringify(report),
      { headers: { 'Content-Type': 'application/json' } }).pipe(map((data) => {
        return <SavedReport>data;
      }));
  }

  delete(id: number): Observable<any> {
    if (!id || id === -1) {
      throw new Error('You must provide a valid id for delete');
    }

    return this.httpClient.delete(this._endpoint + 'saved-report/' + id);
  }
}
